import React from "react";
import styled from "styled-components";
import CharacterCounter from "../../../components/character_counter/character_counter";

/**
 * Quote input + AI help button. Extracted from the monolith
 * (`art_of_the_day-v2.tsx` lines 1697–1724).
 */
export interface AotdQuoteFormProps {
  value: string;
  onChange: (next: string) => void;
  onSubmit: () => void | Promise<void>;
  onSuggest: () => void | Promise<void>;
  helpUsedCount: number;
  suggestionLoading: boolean;
  maxLength?: number;
}

const QuoteForm = styled.form`
  width: 80%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 15px;
`;

const QuoteInput = styled.input`
  font-size: 1rem;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 3px;
  width: 100%;
  margin-bottom: 0.1rem;
`;

const SubmitButton = styled.button`
  grid-column: span 1;
  color: rgb(249, 249, 249);
  border: var(--hm-border);
  border-radius: var(--hm-radius);
  padding: 10px;
  box-shadow: var(--hm-shadow);
  background-color: #444;
  margin: 10px;
  cursor: pointer;
  text-align: center;
  font-size: 16px;
  width: 186px;
  transition-duration: 0.4s;

  &:hover {
    box-shadow: var(--hm-shadow-pressed);
    transform: var(--hm-press-translate);
    background-color: #222;
  }
`;

const HelpButton = styled.button<{ quoteHelp: number }>`
  background-color: ${(props) => (props.quoteHelp >= 3 ? "#a4a4a4" : "#009f6f")};
  grid-column: span 1;
  color: rgb(249, 249, 249);
  border: var(--hm-border);
  border-radius: var(--hm-radius);
  padding: 10px;
  box-shadow: ${(props) => (props.quoteHelp >= 3 ? "" : "var(--hm-shadow)")};
  margin: 10px;
  cursor: pointer;
  text-align: center;
  font-size: 16px;
  width: 186px;
  transition-duration: 0.4s;

  &:hover {
    background-color: ${(props) => (props.quoteHelp >= 3 ? "#a4a4a4" : "#006d4c")};
    box-shadow: ${(props) => (props.quoteHelp >= 3 ? "" : "var(--hm-shadow-pressed)")};
    transform: ${(props) => (props.quoteHelp >= 3 ? "none" : "var(--hm-press-translate)")};
  }
`;

const ButtonContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  @media (max-width: 700px) {
    grid-template-columns: repeat(1, 2fr);
    gap: 10px;
  }
`;

export const AotdQuoteForm: React.FC<AotdQuoteFormProps> = ({
  value,
  onChange,
  onSubmit,
  onSuggest,
  helpUsedCount,
  suggestionLoading,
  maxLength = 45,
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    void onSubmit();
  };

  const handleSuggest = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (helpUsedCount >= 3 || suggestionLoading) return;
    void onSuggest();
  };

  return (
    <QuoteForm onSubmit={handleSubmit}>
      <br />
      <QuoteInput
        type="text"
        value={value}
        maxLength={maxLength}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Enter your quote here..."
      />
      <CharacterCounter count={value.length} maxCount={maxLength} />
      <ButtonContainer>
        <SubmitButton type="submit">Submit Quote</SubmitButton>
        <HelpButton
          type="button"
          disabled={helpUsedCount >= 3 || suggestionLoading}
          quoteHelp={helpUsedCount}
          onClick={handleSuggest}
        >
          {suggestionLoading ? (
            <div className="spinner-in-button" />
          ) : (
            `AI Help (${3 - helpUsedCount} left)`
          )}
        </HelpButton>
      </ButtonContainer>
    </QuoteForm>
  );
};

export default AotdQuoteForm;
